import { PropsWithChildren } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { TransparentButton } from "@coffee/ui/components/buttons";
import { Popover } from "@coffee/ui/components/popover";
import styled from "@emotion/styled";
import {
  ArrowRightStartOnRectangleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import { Icon } from "@unlikelyai-magic/ui/icons";
import { UnlikelyAiLogoWithText } from "@unlikelyai-magic/ui/illustrations";
import { Spacing } from "@unlikelyai-magic/ui/layouts";
import { Paragraph } from "@unlikelyai-magic/ui/typography";

const TopHeaderBar = styled(Spacing)`
  height: 4rem;
  padding: 0.75rem 1rem;
  background-color: ${({ theme }) => theme.colors.background.default};};
`;

const SecondaryHeaderBar = styled(Spacing)`
  height: 3rem;
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => theme.colors.background.client};
  color: ${({ theme }) => theme.colors.text.dark.default};
`;

const LogoutButton = styled(TransparentButton)`
  color: ${({ theme }) => theme.colors.text.dark.default};
`;

export const HeaderBar = ({ children, ...props }: PropsWithChildren) => {
  const { logout } = useAuth0();

  const logoutUser = async () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const DemoLimitations = () =>
    "Refreshing your browser cache will remove all previously asked questions.";

  return (
    <>
      <TopHeaderBar
        direction="horizontal"
        items="center"
        justify="flex-start"
        {...props}
      >
        <Icon icon={UnlikelyAiLogoWithText} size="8rem" />
      </TopHeaderBar>
      <SecondaryHeaderBar
        direction="horizontal"
        items="center"
        justify="space-between"
      >
        <Spacing direction="horizontal" items="center" gap="4xl">
          <Paragraph>Employee Advisor</Paragraph>
          <Popover placement="bottom" trigger="hover" content={DemoLimitations}>
            <div>
              <Spacing direction="horizontal" items="center" gap="xs">
                <Icon icon={InformationCircleIcon} size="1.5rem" />
                Demo limitations
              </Spacing>
            </div>
          </Popover>
        </Spacing>
        <LogoutButton onClick={() => logoutUser()}>
          Log out
          <Icon icon={ArrowRightStartOnRectangleIcon} size="1.5rem" />
        </LogoutButton>
      </SecondaryHeaderBar>
    </>
  );
};
